export default __webpack_public_path__ + "static/media/aluxus_3.56a1f4c6.jpg";